import React from 'react';
import type { FieldValues } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import TextField from '@mui/material/TextField';

import { StyledContainer } from '../styles';
import type { InputProps } from '../types';

export default function InputText<T extends FieldValues>({
  autoComplete,
  autoFocus,
  css,
  control,
  disabled,
  fullWidth = true,
  helperText,
  label,
  name,
  secret,
  InputLabelProps,
  InputStyle,
  multiline,
  rows,
  ...props
}: InputProps<T>) {
  return (
    <StyledContainer css={css} {...props}>
      <Controller<T>
        control={control}
        name={name}
        render={({ field: { onChange, value }, fieldState: { error } }) => {
          return (
            <TextField
              InputLabelProps={InputLabelProps}
              aria-disabled={disabled}
              autoComplete={autoComplete}
              autoFocus={autoFocus}
              disabled={disabled}
              error={!!error}
              fullWidth={fullWidth}
              helperText={error?.message || helperText}
              label={label}
              multiline={multiline}
              onChange={onChange}
              rows={rows}
              type={secret ? 'password' : undefined}
              value={value}
              inputProps={{
                style: InputStyle,
              }}
            />
          );
        }}
      />
    </StyledContainer>
  );
}
